export const SERVICE = {
    //API_URL: "http://localhost:7070", 
    API_URL: "https://invirtiendoplus.com.mx/api",
    //API_URL: "http://192.168.1.68:7070",
    //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
    //ROLES
    getRoles: "/Roles/GetAll",
    insertRol: "/Roles/Post",   
    deleteRol: "/Roles/Delete",
    //REPORTE
    reportPagos: "/Reports/AdvisorDay",
    reportPagosMaps: "/Reports/AdvisorDayMaps",
    //ELEMENTS
    getElements: "/Elements/GetAll",
    //PERMISOS
    getPermision: "/Permissions/GetAll",
    setPermision: "/Permissions/Post",
    deletePermision: "/Permissions/Delete",
    //FINES
    setFiner: "/Fines/Post",
    getByAmortizationTableId: "/Fines/GetByAmortizationTableId?AmortizationTableId=",
    getbyLoanId: "/Fines/GetByLoanId?LoanId=",
    updateFiner: "/Fines/Put",
    DeleteFiner: "/Fines/Delete",
    //USERS
    getUserById:"/Users/",
    deleteUser: "/Users/Delete",
    insertUser: "/Users/Register",
    updateUser: "/Users/Update",
    getUser: "/Users/GetAll",
    login: "/Users/LoginUser",
    getPermisosUser: "/PermissionsByUser/GetByUserId?Type=CentralOffices&UserId=",
    setPermisosUser: "/PermissionsByUser/Post",
    detelePermisosUser: "/PermissionsByUser/Delete",
    //CORDINADORES
    getCordinadores: "/Coordinators/GetMainGrid",
    getCordinadoresAll: "/Coordinators/GetAll",
    setCordinadores: "/Coordinators/Post",
    updateCordinadores: "/Coordinators/Put",
    deleteCordinadores: "/Coordinators/Delete",
    //SUCURSALES
    getOfices: "/CentralOffice/GetAll",
    setOfices: "/CentralOffice/Post",
    updateOfices: "/CentralOffice/Put",
    deleteOfices: "/CentralOffice/Delete",
    //ESTADOS
    getState: "/States/GetAll",
    //MUNICIPIO
    getMunicipal: "/Municipalities/GetAll",
    //CODIGOS POSTALES
    getPostal: "/PostalCodes/GetAll",
    //ASESORES
    getAsesores: "/Advisors/GetMainGrid",
    getAsesoresAll: "/Advisors/GetAll",
    setAsesores: "/Advisors/Post",
    updateAsesores: "/Advisors/Put",
    deleteAsesores: "/Advisors/Delete",
    //PersonalData
    getPersonal: "/PersonalData/GetMainGrid",
    getPersonalById: "/PersonalData/",
    getPersonalAll: "/PersonalData/GetAll",
    detelePersonalData: "/PersonalData/Delete",
    setPersonal: "/PersonalData/Post",
    updatePersonal: "/PersonalData/Put",
    deletePersonal: "/PersonalData/Delete",
    changeAdvisor: "/PersonalData/ChangeAdvisor",
    getClientsAdvisor: "/PersonalData/GetClients",
    //MaritalEstatus
    getMaritalEstatus: "/MaritalStatus/GetAll",
    //Genders
    getGenders: "/Genders/GetAll",
    //SpousesData
    setConyuge: "/SpousesData/Post",
    updateConyuge: "/SpousesData/Put",
    getConyugeById: "/SpousesData/By/",
    //AddressTypes
    getTiposVivienda: "/AddressTypes/GetAll",
    //AddressVerification
    setVerificacionDom: "/AddressVerification/Post",
    updateVerificacionDom: "/AddressVerification/Put",
    getVerificacionDomById: "/AddressVerification/By/",
    
    //DocumentTypes
    getDocumentstypes: "/DocumentTypes/GetAll",

    //ReferenceTypes
    getReferenceTypes: "/ReferenceTypes/GetAll",

    //Documents
    uploadDocuments: "/Documents/UploadDocuments",
    getDocumentsByClient: "/Documents/GetBy/",
    deleteDocuments: "/Documents/Delete",

    //References
    setReference: "/References/Post",
    updateReference: "/References/Put",
    getReferenceById: "/References/By/",

    //BusinessData
    setBussinessData: "/BusinessData/Post",
    updateBussinessData: "/BusinessData/Put",
    getBussinessDataById: "/BusinessData/By/",

    //Questions
    getQuestionsByArea: "/Questions/By/",

    //Warranty
    getWarranty:"/Warranty/By/",
    setWarranty:"/Warranty/Post",
    updateWarranty:"/Warranty/Put",

    //PoliticallyExposedQuestions
    getPoliticallyExposedQuestions:"/PoliticallyExposedQuestions/By/",
    setPoliticallyExposedQuestions:"/PoliticallyExposedQuestions/Post",
    updatePoliticallyExposedQuestions:"/PoliticallyExposedQuestions/Put",

    //Aval
    setAval: "/Backing/Post",
    updateAval: "/Backing/Put",
    deteleAval: "/Backing/Delete",
    getAval: "/Backing/GetAll",
    getAvalGrid: "/Backing/GetMainGrid",
    getAvalId:"/Backing/",

    //AvalCliente
    getAvalClient: "/ClientBacking/By/",
    setAvalClient: "/ClientBacking/Post",
    updateAvalClient: "/ClientBacking/Put",


    //compañias
    getCompanie:"/Companies/GetAll",
    getCompaniegrid:"/Companies/GetMainGrid",
    setCompanie:"/Companies/Post",
    updateCompanie:"/Companies/Put",
    deleteCompanie:"/Companies/Delete",
    setCompanieSuc:"/CompaniesCentralOffices/Post",
    updateCompanieSuc:"/CompaniesCentralOffices/Put",
    getCompanieSuc:"/CompaniesCentralOffices/GetMainGrid?CompanyId=",
    deleteCompanieSuc:"/CompaniesCentralOffices/Delete",
    
    //compañias afiliadas
    getCompanieAf:"/AffiliatedCompanies/GetAll",
    getCompanieAfGrid:"/AffiliatedCompanies/GetMainGrid",
    setCompanieAf:"/AffiliatedCompanies/Post",
    updateCompanieAf:"/AffiliatedCompanies/Put",
    deleteCompanieAf:"/AffiliatedCompanies/Delete",
    setCompanieSucAf:"/AffiliatedCompaniesCentralOffices/Post",
    updateCompanieSucAf:"/AffiliatedCompaniesCentralOffices/Put",
    getCompanieSucAf:"/AffiliatedCompaniesCentralOffices/GetMainGrid?affiliatedCompanyId=",
    deleteCompanieSucAf:"/AffiliatedCompaniesCentralOffices/Delete",

    //compañias asignadas
    getCompaniesAsig: "/AffiliatedCompaniesAssigned/GetAll",
    setCompaniesAsig: "/AffiliatedCompaniesAssigned/Post",
    deleteCompaniesAsig: "/AffiliatedCompaniesAssigned/Delete?Id=",


    //VALES
    getVoucherStatus: "/VoucherStatus/GetAll",
    getVoucher: "/Voucher/GetMainGrid",
    setVale: "/Voucher/Post",
    updateVale: "/Voucher/Put",
    deteleVale: "/Voucher/Delete",

    //Prestamos
    getPrestamos: "/Loans/GetMainGrid",
    getPrestamosTypes: "/LoanSettings/GetAll",
    getPrestamosTypesByType: "/LoanSettings/GetByType?Type=",
    getLoansStatus: "/LoansStatus/GetAll",
    calcularPrestamo:"/Loans/CalculateLoanData",
    setPrestamo: "/Loans/RegisterLoan",
    deletePrestamo: "/Loans/Delete",
    getTableAmor:"/LoansAmortizationTables/GetByLoanId?LoanId=",
    setPago:"/LoansPayments/MakePayment",
    cancelPrestamo:"/LoansWorkFlow/Post",
    getReportPrestamos:"/Reports/ReportInconsistencias",
    getReportClientAddress:"/Reports/ReportClientAddressData",
    setEvaluationLoan: "/Loans/Evaluation",
    //APORTACIONES
    setAportacion:"/AdvisorContributions/MakeAdvisorContribution",

    //Corte de caja
    getInfoCorte: "/CashClosing/GetDataCashClosing",
    setPagoCorte: "/CashClosingItems/Post",
    getPagoCorte: "/CashClosingItems/GetByDateByCentralOfficeId",
    getCortePrint: "/CashClosing/GetReportCashClosing",
    closeCorte: "/CashClosing/Post",
    eliminarItems: "/CashClosingItems/Delete",
    eliminarCorte: "/CashClosing/Delete",
    // Actualizar distribución TC (efectivo / transferencia) en items del corte
    updateTcAmounts: "/TotalBillingAdvisor/Post",
    updateTcAmountsPut: "/TotalBillingAdvisor/Put",

    //reportes
    getReportLoan:"/Loans/GetPDFs/",
    getReportClient:"/PersonalData/ReportPDFClientStatement/",
    //Pagos
    getPayment:"/LoansPayments/GetMainGrid",
    setCommentsPago: "/LoansAmortizationTables/PutComments",
    deletePayment:"/LoansPayments/Delete",
    //Metas
    getInfoMetas:"/GoalsAdvisors/GetReportGoalsdvisors",
    setMeta:"/GoalsAdvisors/Post",
    updateMeta:"/GoalsAdvisors/Put",
    getReportPDFGoals: "/GoalsAdvisors/GetReportPDFGoalsdvisors",
    //dias festivos
    getInfoDiasFestivos:"/Holidays/GetMainGrid",
    setDiasFestivos:"/Holidays/Post",
    updateDiasFestivos:"/Holidays/Put",
    deleteDiasFestivos:"/Holidays/Delete",
    //reportes y graficos
    getDataGraphicLoansColocated:"/Reports/DataGraphicLoansColocated",
    getReportPDFLoansColocated: "/Reports/ReportPDFLoansColocated",
    getDataGraphicLoansOverdue:"/Reports/DataGraphicLoansOverdue",
    getReportPDFLoansOverdue: "/Reports/ReportPDFLoansOverdue",
    getReportPDFClientsByWeek: "/Reports/ReportPDFClientsWeeksInMonth",
    getReportPDFClientsNRN: "/Reports/AdvisorLoansNoRenew",
    //log de auditoria
    getAuditLog : "/AuditLog/GetMainGrid",
    //nómina
    getPayrollAdvisors: "/PayrollAdvisors/GetMainGrid",
    getPayrollAdvisorsDetails: "/PayrollAdvisorsDetails/GetMainGrid",
    setPayrollAdvisors: "/PayrollAdvisors/Post",
    setPayrollAdvisorsDetails: "/PayrollAdvisorsDetails/Post",

    updatePayrollAdvisors: "/PayrollAdvisors/Put",
    updatePayrollAdvisorsDetails: "/PayrollAdvisorsDetails/Put",
    deletePayrollAdvisors: "/PayrollAdvisors/Delete",
    deletePayrollAdvisorsDetails: "/PayrollAdvisorsDetails/Delete",

    //Lista negra
    getReasonsBannedList: "/ReasonsBannedListClient/GetAll",
    setReasonsBannedList: "/ReasonsBannedListClient/Post",
    deleteReasonsBannedList: "/ReasonsBannedListClient/Delete",
    setBannedListClient: "/BannedListClient/Post",
    getBannedListHistory: "/BannedListClient/GetMainGrid",

    //Comunicaciones
    getCommunications: "/Communications/GetMainGrid",
    postCommunication: "/Communications/Post",
    postCommunicationShared: "/CommunicationsShared/Post",
    deleteCommunication: "/Communications/Delete",


}
export const STORAGE = {
    ACCESS_TOKEN: "token"
}
export const APP_OPTIONS = {
    TABLE_SETTING: {
        headRow: {
            style: {
                minHeight: "40px",
                backgroundColor: "#F2F6F9",
                fontSize: "15px",
                color: "black",
                fontWeight: "Bold",
            },
        },
        
    },
    TABLE_SETTING_SM: {
        headRow: {
            style: {
                minHeight: "40px",
                backgroundColor: "#F2F6F9",
                fontSize: "18px",
                color: "black",
                fontWeight: "Bold",
            },
        },
        rows: {
            style: {
                fontSize: "18px",
            },
        },
        
    },
    TABLE_SETTING_CORTE: {
        headRow: {
            style: {
                minHeight: "40px",
                backgroundColor: "#F2F6F9",
                fontSize: "13px",
                color: "black",
                fontWeight: "Bold",
            },
        },
    },
    TABLE_SETTING2: {
        headRow: {
            style: {
                minHeight: "40px",
                backgroundColor: "#0d6ffd",
                fontSize: "15px",
                color: "white",
                fontWeight: "Bold",
            },
        },
    }
}
export const FUNTIONS = {
    calculateAge : (birthDate) => {
        const birthDateObj = new Date(birthDate);
        const today = new Date();
        
        let age = today.getFullYear() - birthDateObj.getFullYear();
        const monthDiff = today.getMonth() - birthDateObj.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
          age--;
        }
        
        return age;
    }
}
